/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Provider/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Bluefin from './Bluefin/index'
import Payabli from './Payabli/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Provider({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Provider"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Payabli'
let providerAccountProviderValueData = fromData.useDataFormat({ viewPath,
context: 'provider_account',
path: 'provider',
format: fromFormat.capitalize,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: providerAccountProviderValueData,
})
  return (<React.Fragment
>
<div
  data-testid="Provider.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<fromFlow.When is={flowValue === 'Payabli'}>
<Payabli
  viewPath={`${viewPath}/Payabli`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Bluefin'}>
<Bluefin
  viewPath={`${viewPath}/Bluefin`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}